import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AnimationService } from 'src/app/utils/animation.service';
import { Constants } from '../../utils/constants';
import { UtmService } from '../../utils/utm.service';

@Component({
  selector: 'app-key-benefits',
  templateUrl: './key-benefits.component.html',
  styleUrls: ['../home.component.scss', './key-benefits.component.scss']
})
export class KeyBenefitsComponent implements OnInit {
  studyWithUsButtonPath: String = Constants.studyWithUsButtonPath;
  formGenericUrl: string = Constants.formGenericUrl;

  @ViewChild('cardsAnimation')
  cardsAnimation: ElementRef;

  constructor(private animation: AnimationService, private utmService: UtmService) { }

  ngOnInit(): void {
    this.formGenericUrl = this.utmService.getFormPath();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animation.startDownToUpAnimation(this.cardsAnimation.nativeElement);
  }
}
